import React from "react";
import AboutUs from "../images/ayushi-about.jpg";

import AboutSection from "../components/AboutPage/AboutSection";
import Heros from "../components/Heros";
import ContactSection from "../components/AboutPage/ContactSection";
import CountSection from "../components/AboutPage/CountSection";
import OurProjects from "../components/AboutPage/OurProjects";
import { Helmet } from "react-helmet-async";

function About() {
  return (
    <>
      <Helmet>
        <title>About Ayushi Construction | Trusted Builder in Jabalpur</title>
        <meta
          name="description"
          content="Ayushi Construction has been building quality homes in Jabalpur since 2005. Learn about our journey, our RERA-registered projects, and the values we build on."
        />
        <meta
          name="keywords"
          content="about ayushi construction jabalpur, trusted builder jabalpur, RERA registered builder jabalpur"
        />
        <link rel="canonical" href="https://ayushiconstruction.com/about" />
      </Helmet>

      <Heros title="About Us" backgroundImage={ AboutUs } />

      <AboutSection />
      <OurProjects />

      <ContactSection />
      <CountSection />
    </>
  );
}

export default About;
